var _path, _path2, _path3, _path4, _line, _line2, _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetric({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 127,
    viewBox: "0 0 260 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 5H231.909L255 21.4971V101.817L228.232 122H57.0346L27 105.309V5Z",
    fill: "white",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4318 79.1215V91.768C24.4318 99.8217 28.3369 107.376 34.908 112.032L45.3438 119.428C49.5415 122.402 54.5593 124 59.7042 124H134.163",
    stroke: "black",
    strokeWidth: 4.73078
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M257.422 77.4594V92.1082C257.422 100.886 252.789 109.012 245.234 113.483L233.312 120.538C229.482 122.804 225.113 124 220.663 124H156.71",
    stroke: "black",
    strokeWidth: 4.73078
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M256.88 49.4904V34.5569C256.88 26.0728 252.549 18.1756 245.396 13.6146L235.428 7.25958C231.439 4.71636 226.807 3.36528 222.076 3.36528H164.238",
    stroke: "black",
    strokeWidth: 4.73078
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: -2.36539,
    x2: 57.9519,
    y2: -2.36539,
    transform: "matrix(-0.00624449 -0.999981 0.999995 -0.00307861 27.8004 58.951)",
    stroke: "black",
    strokeWidth: 4.73078
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 25.9352,
    y1: 3.06766,
    x2: 120.62,
    y2: 3.06766,
    stroke: "black",
    strokeWidth: 4.73078
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.45614,
    y: 33.4561,
    width: 51.0877,
    height: 51.0877,
    rx: 6.8421,
    fill: "url(#paint0_linear_13_34)",
    stroke: "url(#paint1_linear_13_34)",
    strokeWidth: 0.912281
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13_34",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 42,
    width: 34,
    height: 34
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 42,
    width: 34,
    height: 34,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13_34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 59C26.7792 59 27.4462 58.7226 28.001 58.1677C28.5559 57.6129 28.8333 56.9458 28.8333 56.1667C28.8333 55.3875 28.5559 54.7205 28.001 54.1656C27.4462 53.6108 26.7792 53.3333 26 53.3333C25.2208 53.3333 24.5538 53.6108 23.9989 54.1656C23.4441 54.7205 23.1667 55.3875 23.1667 56.1667C23.1667 56.9458 23.4441 57.6129 23.9989 58.1677C24.5538 58.7226 25.2208 59 26 59ZM26 69.4125C28.8805 66.7681 31.0174 64.3656 32.4104 62.2052C33.8035 60.0448 34.5 58.1264 34.5 56.45C34.5 53.8764 33.6795 51.7691 32.0385 50.1281C30.3976 48.4872 28.3847 47.6667 26 47.6667C23.6153 47.6667 21.6024 48.4872 19.9614 50.1281C18.3205 51.7691 17.5 53.8764 17.5 56.45C17.5 58.1264 18.1965 60.0448 19.5896 62.2052C20.9826 64.3656 23.1194 66.7681 26 69.4125ZM26 73.1667C22.1986 69.9319 19.3594 66.9274 17.4823 64.1531C15.6052 61.3788 14.6667 58.8111 14.6667 56.45C14.6667 52.9083 15.8059 50.0868 18.0844 47.9854C20.3628 45.884 23.0014 44.8333 26 44.8333C28.9986 44.8333 31.6371 45.884 33.9156 47.9854C36.1941 50.0868 37.3333 52.9083 37.3333 56.45C37.3333 58.8111 36.3948 61.3788 34.5177 64.1531C32.6406 66.9274 29.8014 69.9319 26 73.1667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_34",
    x1: 26,
    y1: 33,
    x2: 26,
    y2: 85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161C21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A7387"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13_34",
    x1: 7.83611,
    y1: 33.6855,
    x2: 55.9892,
    y2: 69.2401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetric);
export default __webpack_public_path__ + "static/media/metric.d9d0d3ea190a0684c97bce9debcee78a.svg";
export { ForwardRef as ReactComponent };